import { render, staticRenderFns } from "./ActsDetail.vue?vue&type=template&id=60aa8b37&scoped=true"
import script from "./ActsDetail.vue?vue&type=script&lang=js"
export * from "./ActsDetail.vue?vue&type=script&lang=js"
import style0 from "./ActsDetail.vue?vue&type=style&index=0&id=60aa8b37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa8b37",
  null
  
)

export default component.exports